<template>
  <a-locale-provider :locale="locale">
    <div class="order-search-container">
      <div class="order-search-tab">
        <a-tabs
          defaultActiveKey="0"
          v-model="activeTabKey"
        >
          <!--简单查询-->
          <a-tab-pane tab="订单记录" key="1">
            <a-form class="order-search-form" :form="simpleForm" :layout="formLayout">
              <a-row>
                <a-col :xs="24" :xl="12">
                  <a-form-item
                    label="订票日期"
                  >
                    <a-date-picker
                      class="form-input-xl-fix"
                      placeholder="选择日期"
                      v-model="orderStartDate"
                      :disabledDate="startDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      class="form-input-xl-fix"
                      placeholder="选择日期"
                      v-model="orderEndDate"
                      :disabledDate="endDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
                  <a-col :xs="24" :xl="12">
                    <a-form-item>
                      <a-button class="order-primary-btn"
                                type="primary"
                                :loading="orderLoading"
                                @click="simpleFormSubmitHandler"
                      >
                        查询
                      </a-button>
                    </a-form-item>
                  </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
          <!--精准查询-->
          <a-tab-pane tab="精准查询" key="2">
            <a-form class="order-search-form" :form="fullForm" :layout="formLayout">
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="订单号"
                  >
                    <a-input
                      v-decorator="[
                      'intlOrderNo',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur'
                        }
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="订票日期"
                  >
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="orderStartDate"
                      :disabledDate="startDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="orderEndDate"
                      :disabledDate="endDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol" class="form-item-ticket">
                  <a-form-item
                    label="票号"
                  >
                    <a-input
                      class="input-ticket-prefix"
                      v-decorator="[
                      'issCode',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur',
                          initialValue: issCode
                        }
                      ]"
                    />
                  </a-form-item>
                  <div class="form-split split-ticket">-</div>
                  <a-form-item>
                    <a-input
                      class="input-ticket"
                      v-decorator="[
                      'ticketNo',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur'
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="航段"
                  >
                    <l8-flightcityselector
                      v-model="depCity"
                      placeholder="出发城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <l8-flightcityselector
                      v-model="arrCity"
                      placeholder="到达城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="PNR"
                  >
                    <a-input v-model="pnr"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="航班日期"
                  >
                    <a-date-picker
                      placeholder="开始时间"
                      v-model="segStartDate"
                      :disabledDate="startSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="结束时间"
                      v-model="segEndDate"
                      :disabledDate="endSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :xl="fullTabLCol">
                  <a-form-item
                    label="航班号"
                  >
                    <a-input v-model="flightNo"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :xl="fullTabRCol">
                  <a-form-item
                    label="订单状态"
                  >
                    <a-select v-model="orderStatus" defaultValue="">
                      <a-select-option value="">全部</a-select-option>
                      <a-select-option value="WP">等待付款</a-select-option>
                      <a-select-option value="PF">已出票</a-select-option>
                      <a-select-option value="HP">支付未出票</a-select-option>
                      <a-select-option value="XX">已取消</a-select-option>
                      <!-- <a-select-option value="WF">等待确认乘客</a-select-option> -->
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-button
                      class="order-primary-btn"
                      type="primary"
                      :loading="orderLoading"
                      @click="fullFormSubmitHandler"
                    >
                      查询
                    </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="order-search-table">
        <a-table class="order-table"
                 :dataSource='orderListData'
                 :columns='orderListCols'
                 :pagination="orderPagination"
                 :loading="orderLoading"
                 @change="orderListChangeHandler"
        >
          <a class="l8-href" slot="orderNo"  slot-scope="orderNo, record" target="_blank" :href="'http://internation.luckyair.net/order/detail/' + record.orderId">{{ orderNo }}</a>
          <div slot="segments" slot-scope="segments">
            <p v-for="(seg, segIndex) in segments" :key="segIndex">{{seg}}</p>
          </div>
          <div slot="flightNo" slot-scope="flightNo">
            <p v-for="(fNo, idx) in flightNo" :key="idx">{{fNo}}</p>
          </div>
          <div slot="flightDate" slot-scope="flightDate">
            <p v-for="(fDate, idx) in flightDate" :key="idx">{{fDate}}</p>
          </div>
          <div slot="flightTime" slot-scope="flightTime">
            <p v-for="(fTime, idx) in flightTime" :key="idx">{{fTime}}</p>
          </div>
        </a-table>
      </div>
      <div class="order-ext" v-if="orderListData.length">
        <div class="order-ext-btn" title="导出PDF">
          <l8-icon class="l8-icon" type="icon-pdf" @click="exportHandler('PDF')"/>
        </div>
        <div class="order-ext-btn" title="导出Excel">
          <l8-icon class="l8-icon" type="icon-Excel" @click="exportHandler('Excel')"/>
        </div>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import { queryIntlList } from '@/apis/order'
import '@/components/l8-icon'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { validate } from '@/assets/js/validate'
import moment from 'moment'
import { map, sortBy, each } from 'lodash'
import axios from 'axios'
import getAppInfo from '@/utils/from'
import './index'

const orderStatusMaps = {
  'WP': 3,
  'XX': 300,
  'PF': 6,
  'HP': 5
}

const orderListCols = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key'
  },
  {
    title: '订单号',
    dataIndex: 'orderNo',
    key: 'orderNo',
    scopedSlots: { customRender: 'orderNo' }
  },
  {
    title: '航段',
    dataIndex: 'segments',
    key: 'segments',
    scopedSlots: { customRender: 'segments' }
  },
  {
    title: '航班号',
    dataIndex: 'flightNo',
    key: 'flightNo',
    scopedSlots: { customRender: 'flightNo' }
  },
  {
    title: '航班日期',
    dataIndex: 'flightDate',
    key: 'flightDate',
    scopedSlots: { customRender: 'flightDate' }
  },
  {
    title: '起飞时间',
    dataIndex: 'flightTime',
    key: 'flightTime',
    scopedSlots: { customRender: 'flightTime' }
  },
  {
    title: '订票时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },
  {
    title: '状态',
    dataIndex: 'statusCn',
    key: 'statusCn'
  }
]

export default {
  data () {
    return {
      international: true,
      locale: zhCN,
      fullTabLCol: 9,
      fullTabRCol: 15,
      activeTabKey: '1',
      formLayout: 'inline',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      simpleForm: this.$form.createForm(this),
      fullForm: this.$form.createForm(this),
      orderListData: [],
      orderListCols: orderListCols,
      orderPagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showSizeChanger: true,
        showQuickJumper: true,
        total: 10
      },
      orderLoading: true,
      // 查询参数
      page: 1,
      pageSize: 10,
      orderStartDate: null,
      orderEndDate: null,
      issCode: getAppInfo()?.ticketCode,
      depCity: '',
      arrCity: '',
      orderStatus: '',
      flightNo: '',
      segEndDate: null,
      segStartDate: null,
      pnr: '',
      ticketNo: '',
      orderNo: ''
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        let width = window.innerWidth
        if (width < 992) {
          that.formLayout = 'horizontal'
        } else {
          that.formLayout = 'inline'
        }
      })()
    }
  },
  created () {
    let width = window.innerWidth
    if (width < 992) {
      this.formLayout = 'horizontal'
    }

    this.fetchOrderList()
  },
  computed: {
    queryStartDate () {
      if (this.orderStartDate) {
        return this.orderStartDate.format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    queryEndDate () {
      if (this.orderEndDate) {
        return this.orderEndDate.format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    queryParams () {
      let params
      if (this.activeTabKey === '1') {
        params = {
          'orderStartDate': this.queryStartDate,
          'orderEndDate': this.queryEndDate,
          'page': this.page,
          'pageSize': this.pageSize,
          'condition': '1'
        }

        if (this.international) {
          params.status = orderStatusMaps[this.orderStatus] || ''
        }
      } else {
        params = {
          'condition': '2',
          'orderStartDate': this.queryStartDate,
          'orderEndDate': this.queryEndDate,
          'page': this.page,
          'pageSize': this.pageSize,
          'issCode': this.issCode || '',
          'orgCity': this.depCity || '',
          'dstCity': this.arrCity || '',
          'status': orderStatusMaps[this.orderStatus] || '',
          'flightNo': this.flightNo || '',
          'flightEndDate': this.segEndDate || '',
          'flightStartDate': this.segStartDate || '',
          'pnr': this.pnr || '',
          'ticketNo': this.ticketNo || '',
          'orderNo': this.orderNo || ''
        }
      }

      return params
    }
  },
  methods: {
    startDisabledDate (current) {
      return current && current > moment().endOf('day')
    },
    endDisabledDate (current) {
      if (this.orderStartDate) {
        return current && (current < this.orderStartDate.startOf('day') || current > moment().endOf('day'))
      } else {
        return current && current > moment().endOf('day')
      }
    },
    startSegDisabledDate (current) {
      if (this.segEndDate) {
        return current && (current > this.segEndDate.endOf('day'))
      } else {
        return false
      }
    },
    endSegDisabledDate (current) {
      if (this.segStartDate) {
        return current && (current < this.segStartDate.startOf('day'))
      } else {
        return false
      }
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.fullForm.getFieldsValue()
      validate('ordersearch', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    orderListChangeHandler (pagination) {
      this.page = pagination.current
      this.pageSize = pagination.pageSize

      this.fetchOrderList()
    },
    simpleFormSubmitHandler () {
      this.page = 1
      this.fetchOrderList()
    },
    fullFormSubmitHandler () {
      this.fullForm.validateFieldsAndScroll((errors, values) => {
        if (!errors) {
          this.orderNo = values.intlOrderNo || ''
          this.issCode = values.issCode || ''
          this.ticketNo = values.ticketNo || ''
          this.page = 1
          this.fetchOrderList()
        }
      })
    },
    async fetchOrderList () {
      this.orderLoading = true

      try {
        const res = await queryIntlList(this.queryParams)

        this.orderLoading = false
        this.updateOrderList(res.list)
        this.$set(this.orderPagination, 'current', res.currentPageNumber)
        this.$set(this.orderPagination, 'total', res.totalResultCount || 0)
      } catch (err) {
        this.orderLoading = false

        this.$message.error(err.message || '订单查询失败，请稍后再试')
      }
    },
    updateOrderList (orderList) {
      let orderData = map(orderList, (order, index) => {
        let item = {
          key: index + 1,
          orderId: order.id,
          orderNo: order.orderNo,
          createTime: moment(order.createTime).format('YYYY-MM-DD'),
          statusCn: order.statusCn,
          segments: [],
          flightNo: [],
          flightDate: [],
          flightTime: []
        }

        let sortSegs = sortBy(order.segmentList, (c) => {
          return c.depTime
        })

        each(sortSegs, (seg, segIndex) => {
          item.segments.push(seg.depName + '-' + seg.arrName)
          item.flightNo.push(seg.flightNo)
          item.flightDate.push(moment(seg.depTime).format('YYYY-MM-DD'))
          item.flightTime.push(moment(seg.depTime).format('HH:mm:ss'))
        })

        return item
      })

      this.orderListData = orderData
    },
    exportFile (type) {
      let params = this.queryParams
      let urlMap = {
        'PDF': '/api/userOrder/exportPDF',
        'Excel': '/api/userOrder/exportExcel'
      }

      let _params = {
        ...params,
        isAll: true
      }

      let url = urlMap[type]

      axios({
        method: 'post',
        url: url,
        data: _params,
        responseType: 'blob'
      }).then(({ status, data }) => {
        if (status === 200) {
          if (!window.Blob) {
            this.$message.error('该浏览器不支持数据流下载，请更换浏览器')
            return
          }

          const blob = new Blob([data])
          const fileName = `订单列表.${type === 'PDF' ? 'pdf' : 'xls'}`

          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }
        } else {
          this.$message.error('网络异常，请稍后再试！')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    exportHandler (type) {
      this.$modal.confirm({
        title: '提示',
        content: '是否导出' + type + '文件？',
        cancelText: '取消',
        okText: '确认',
        onOk: () => {
          this.exportFile(type)
        }
      })
    }
  }
}
</script>

<style lang="less">
  .order-search-container {
    padding: 20px;
    position: relative;
  }

  .ant-btn.order-primary-btn {
    width: 100px;
    height: 42px;
  }

  /*查询表单样式*/
  .order-search-form {

    &.ant-form-inline {
      .ant-form-item {
        &.ant-row {
          margin-bottom: 16px;
        }
      }

      .ant-form-item-label label {
        color: #333;
        width: 90px;
        display: inline-block;
      }
    }

    .input-ticket-prefix {
      width: 50px;
    }

    .input-ticket {
      width: 94px;
    }

    .ant-input {
      height: 48px;
    }

    .ant-form-explain {
      margin-top: 0;
    }

    .form-item-ticket {
      .ant-form-explain {
        margin-right: -60px;
      }
    }

    .ant-select,
    .ant-cascader-picker {
      width: 182px;
      display: inline-block;
    }

    .ant-select-selection--single {
     height: 48px;
    }

    .ant-select-selection__rendered {
      line-height: 48px;
    }

    .form-split {
      display: inline-block;
      margin-right: 16px;
      line-height: 51.999px;
    }
  }

  /*订单列表*/
  .order-table {
    table {
      td {
        vertical-align: middle;
      }
    }

    .l8-href {
      text-decoration: underline;
    }
  }

  /*订单列表导出*/
  .order-ext {
    position: absolute;
    bottom: 38px;
    left: 20px;
    z-index: 1;
  }

  .order-ext-btn {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;

    .l8-icon {
      font-size: 26px;
    }
  }

  @media only screen and (max-width: 992px) {
    .order-search-form   {
      .ant-form-item {
        &.ant-row {
          margin-bottom: 6px;
        }
      }

      .input-ticket-prefix {
        width: 100%;
      }

      .input-ticket {
        width: 100%;
      }

      .ant-form-item-label {
        margin-bottom: 5px;
      }

      .ant-calendar-picker {
        width: 100%;
      }

      .ant-select,
      .ant-cascader-picker {
        width: 100%;
        display: inline-block;
      }

      .form-split {
        display: block;
        line-height: 30px;
      }
    }

    .order-table {
      table {
        td {
          vertical-align: middle;
          min-width: 120px;
        }
      }

      .ant-table {
        overflow-x: scroll;
        word-break: keep-all;
      }
    }

    .ant-btn.order-primary-btn {
      width: 100%;
    }

    .order-ext {
      position: relative;
      bottom: 0;
      left: 0;
      z-index: 1;
    }
  }

  @media (min-width: 1200px) and (max-width: 1300px) {
    .order-search-form   {
      .form-input-xl-fix {
        .ant-input {
          width: 120px;
        }
      }
    }
  }
</style>
